/**
 * Whether a value is a legislation record number ("O2026-0012345", "2026-1829", "Int 0123-2026"), not a model's "none":
 * "unknown", "not stated", a placeholder or instruction it echoed back ("unknown_record_not_stated - use empty string"),
 * or the prompt's own example. The meeting analysis drops the rest (worker/src/analysis.js clean), and the meeting page
 * never shows them (stores/meetingStore.ts), whatever an older analysis saved.
 */
export const PROMPT_EXAMPLE_RECORD = "O2026-0012345";   // analysis.js CHICAGO_WORDS.recordExample

export function isRecordId(value: unknown, example: string = PROMPT_EXAMPLE_RECORD): boolean {
  const s = String(value ?? "").trim();
  return !!s && s.length <= 32 && /\d/.test(s) && !/_|\s{2}|\b(unknown|not stated|none|n\/a|placeholder|empty|null|tbd|record)\b/i.test(s) && s !== example;
}
